import styled from 'styled-components';

const SectionMaxWidthContainer = styled.div`
	margin: 0 auto;
	max-width: 1170px;
	padding: 0 2rem;
`;

export const Styled = {
	SectionMaxWidthContainer,
};
